<template>
  <div id="app">
    <component :is="layout || 'div'">
      <router-view />
    </component>

    <CToaster placement="bottom-end">
      <CToast
        v-if="updateExists"
        :key="'updateAppToast'"
        :visible="updateExists"
        :autohide="false"
      >
        <h5 class="mb-3">
          An update is available
        </h5>
        <CButton
          color="success"
          variant="outline"
          size="sm"
          @click="refreshApp"
        >
          Update
        </CButton>
      </CToast>
    </CToaster>
  </div>
</template>

<script>
import updateAppMixin from './mixins/update-app-mixin'

export default {
  name: 'App',

  mixins: [updateAppMixin],

  computed: {
    layout() {
      return this.$route.matched.find(m => !!m.meta.layout)?.meta?.layout 
    }
  },

}
</script>

<style lang="scss">
// Import Main styles for this application
@use 'assets/scss/style';
</style>
